import { useCallback } from "react";

import {
  categorizeEventsByRecurrence,
  manageCalendarRecurringEvents,
} from "../../utils/calendar/initializeDataUtils";

import { convertServerToClientBlockType } from "../../utils/common/block/type-converter";

import { usePreference } from "../preference/usePreference";
import { useSetRecoilState } from "recoil";
import { recurrenceOriginalBlockState } from "../../recoil/block/recurrence";

export const useProcessCalendarBlocks = () => {
  const { preference: userPreference } = usePreference();
  const defaultVisibility = userPreference?.defaultVisibility;
  const setRecurrenceOriginalBlockState = useSetRecoilState(recurrenceOriginalBlockState);

  const processInitialCalendarBlocks = useCallback(
    (events, recurringEnd) => {
      const formattedEvents = events.map((event) =>
        convertServerToClientBlockType({
          serverBlock: event,
          defaultVisibility,
          wholeServerBlocks: events,
        })
      );

      // 2. 이벤트 분류
      const categorizedEvents = categorizeEventsByRecurrence(formattedEvents);

      // 반복 모체 블록 전역상태 세팅
      const recurrenceOriginalBlocks = categorizedEvents.recurrenceBlocks.filter(
        (item) => !item.originalId
      );
      setRecurrenceOriginalBlockState((prevState) => {
        const newMap = new Map(prevState); // 기존 상태 복사

        // 새로운 블록들을 Map에 추가
        recurrenceOriginalBlocks.forEach((block) => {
          newMap.set(block.id, block);
        });

        return newMap;
      });

      // 3. 반복 이벤트 처리
      const recurringEvents = manageCalendarRecurringEvents(
        categorizedEvents.recurrenceBlocks,
        categorizedEvents.recurrenceUpdatedBlocks,
        recurringEnd
      );

      return [...categorizedEvents.normalBlocks, ...recurringEvents];
    },
    [defaultVisibility]
  );

  return { processInitialCalendarBlocks };
};
